module.exports = __webpack_public_path__ + "media/images/app/collections/collection-designer-59e3012147c69c9e841e67cb6d91afa6.webp";